module.exports = __webpack_public_path__ + "img/22.8cdc3d79.jpg";